import React, { useEffect, useState } from 'react';
import { PartnerApi } from '../../../api/partnerApi';
import Loader from '../../../component/common/Loader';
import DonutChartCard from '../../../component/common/cards/DonutChartCard';

function PartnerCount({ companyComparsion = false }) {
  const [loader, setLoader] = useState(false);
  const [companyData, setCompanyData] = useState([]);

  const getCompanyCount = () => {
    setLoader(true);
    PartnerApi.getPartnerContentCounts()
      .then((res) => {
        setLoader(false);
        const data = res.data?.data;
        if (res.data?.meta.code === 1) {
          let arr = [
            {
              name: 'All Companies',
              data: [
                {
                  label: 'Active',
                  value: data?.activeCompanies,
                  percentage: data?.activeCompanies,
                  color: '#3A47AB'
                },
                {
                  label: 'Inactive',
                  value: data?.inactiveCompanies,
                  percentage: data?.inactiveCompanies,
                  color: '#c6caeb'
                }
              ]
            },
            {
              name: 'Companies in negotiation',
              data: [
                {
                  label: 'Active',
                  value: data?.negotiationActive,
                  percentage: data?.negotiationActive,
                  color: '#F05289'
                },
                {
                  label: 'Inactive',
                  value: data?.negotiationInactive,
                  percentage: data?.negotiationInactive,
                  color: '#f9b9cf'
                }
              ]
            },
            {
              name: 'Company signed',
              data: [
                {
                  label: 'Active',
                  value: data?.signedActive,
                  percentage: data?.signedActive,
                  color: '#71c837'
                },
                {
                  label: 'Inactive',
                  value: data?.signedInactive,
                  percentage: data?.signedInactive,
                  color: '#d4efc3'
                }
              ]
            },
            {
              name: 'B2B users',
              data: [
                {
                  label: 'Active',
                  value: data?.activeCompaniesUsers,
                  percentage: data?.activeCompaniesUsers,
                  color: '#731c3f'
                },
                {
                  label: 'Inactive',
                  value: data?.inactiveCompaniesUsers,
                  percentage: data?.inactiveCompaniesUsers,
                  color: '#f0c1d4'
                }
              ]
            },
            {
              name: 'Total seats under contract',
              data: [
                {
                  label: 'Active',
                  value: data?.totalactiveSeats,
                  percentage: data?.totalactiveSeats,
                  color: '#d5b810'
                },
                {
                  label: 'Inactive',
                  value: data?.totalinactiveSeats,
                  percentage: data?.totalinactiveSeats,
                  color: '#faf0b8'
                }
              ]
            }
          ];
          // if(companyComparsion){
          //     arr.push()
          // }
          setCompanyData(arr);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  useEffect(() => {
    getCompanyCount();
  }, []);

  return (
    <div className="flex flex-col">
      {loader ? <Loader /> : null}
      <div className="grid gap-5 lg:grid-cols-2 md:grid-cols-3 sm:grid-cols-2 2xl:grid-cols-5 xl:grid-cols-4">
        {companyData.map((value, key) => (
          <DonutChartCard
            key={key}
            data={value.data}
            title={value.name}
            labelClassName={'w-full sm:min-h-[60px] 2xl:min-h-full'}
            hidePercentage
            className={'md:w-full lg:w-full'}
          />
        ))}
      </div>
    </div>
  );
}

export default PartnerCount;
